module.exports = require("js-yaml");


//////////////////
// WEBPACK FOOTER
// external "js-yaml"
// module id = 524
// module chunks = 0